import { useEffect, useState } from 'react';
import type { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { CssBaseline, ThemeProvider, useMediaQuery } from '@material-ui/core';
import { initializeI18n } from './i18n';
import { RTL } from './components/rtl';
import { gtmConfig } from './config';
import { useSettings } from './contexts/settings-context';
import { useAuth } from './hooks/use-auth';
import gtm from './lib/gtm';
import routes from './routes';
import { createCustomTheme } from './theme';
import ErrorBoundary from './ErrorBoundary';
import loadingContext from './loderContext';
import viewContext from './viewContext';
import { CircularLoader } from './components/common/circularLoader';

export const App: FC = () => {
  const content = useRoutes(routes);
  const { settings } = useSettings();
  const { isInitialized } = useAuth();
  const [loading, setLoading] = useState(false);
  const mobileView = useMediaQuery('(max-width:768px)');
  const tabView = !useMediaQuery('(min-width:900px)');
  useEffect(() => {
    gtm.initialize(gtmConfig);
    initializeI18n(settings.language);
  }, [settings]);

  const theme = createCustomTheme({
    direction: settings.direction,
    // theme: settings.theme
    theme: 'light'
  });

  return (
    <viewContext.Provider value={{ mobileView, tabView }}>
      <loadingContext.Provider value={{ loading, setLoading }}>
        <ErrorBoundary>
          <ThemeProvider theme={theme}>
            <RTL direction={settings.direction}>
              <CssBaseline />
              {isInitialized && content}
            </RTL>
          </ThemeProvider>
        </ErrorBoundary>
        { loading && (
          <CircularLoader />
        )}
      </loadingContext.Provider>
    </viewContext.Provider>
  );
};
